import { TableRow } from '@chilecompra/react-kit/components'
import React from 'react'

import { SANCTIONS_ROWS_PER_PAGE } from '../../../config/settings/constant'
import { SANCTIONS_TABLE_HEADER } from '../HistoricalSanctionsList.constants'
import { Skeleton, TableCell } from '../HistoricalSanctionsList.styles'
import SanctionsTable from './SanctionsTable'

/**
 * The loading skeleton, matching the table columns and page size.
 */
const TableSkeleton = () => (
  <SanctionsTable>
    {Array.from({ length: SANCTIONS_ROWS_PER_PAGE }).map((_, rowIndex) => (
      <TableRow key={rowIndex}>
        {SANCTIONS_TABLE_HEADER.map(({ key }) => (
          <TableCell key={key} padding="12px 16px">
            <Skeleton variant="rect" width="90%" />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </SanctionsTable>
)

export default TableSkeleton
